import service from "../services/productionTransfers.service";

export const productionTransfers = {
    namespaced: true,
    state: {
        data: [],
        currentPage: 1,
        lastPage: 1,
        links: [],
        selected: null,
        loading: false,
    },
    getters: {
        transfers: (state) => state.data,
        pagination: (state) => ({
            currentPage: state.currentPage,
            lastPage: state.lastPage,
            links: state.links,
        }),
        selectedTransfer: (state) => state.selected,
        isLoading: (state) => state.loading,
    },
    mutations: {
        SET_DATA(state, payload) {
            state.data = payload;
        },
        SET_PAGINATION(state, { currentPage, lastPage, links }) {
            state.currentPage = currentPage;
            state.lastPage = lastPage;
            state.links = links;
        },
        SET_SELECTED(state, payload) {
            state.selected = payload;
        },
        SET_LOADING(state, status) {
            state.loading = status;
        },
    },
    actions: {
        async fetchData({ commit }, params = null) {
            commit("SET_LOADING", true);

            try {
                const response = await service.getAll(params ?? {});
                const payload = response.data;

                if (Array.isArray(payload)) {
                    commit("SET_DATA", payload);
                    commit("SET_PAGINATION", { currentPage: 1, lastPage: 1, links: [] });
                } else {
                    commit("SET_DATA", payload.data ?? []);
                    commit("SET_PAGINATION", {
                        currentPage: payload.current_page ?? 1,
                        lastPage: payload.last_page ?? 1,
                        links: payload.links ?? [],
                    });
                }
            } catch (error) {
                console.error("Error al obtener los traslados de producción:", error?.response?.status, error?.response?.data);
            } finally {
                commit("SET_LOADING", false);
            }
        },
        async save(context, data) {
            try {
                if (data.id && data.id !== 0) {
                    return await service.updateData(data.id, data);
                }

                return await service.createData(data);
            } catch (error) {
                console.error("Error al guardar el traslado de producción:", error);
                throw error.response ?? error;
            }
        },
        async delete(context, id) {
            try {
                return await service.deleteData(id);
            } catch (error) {
                console.error("Error al eliminar el traslado de producción:", error);
                throw error.response ?? error;
            }
        },
        async getData({ commit }, id) {
            try {
                const response = await service.getData(id);
                commit("SET_SELECTED", response.data);
                return response.data;
            } catch (error) {
                console.error("Error al consultar el traslado de producción:", error);
                throw error.response ?? error;
            }
        },
    },
};

